import Base from "@/controllers/base";
import NApp from "./app";
export default class Payments extends Base {
  constructor(elem) {
    super(elem);
  }

  init() {
    super.init();
    this.showRelatedAdjustments();
  }

  showRelatedAdjustments() {
    const selected = [];
    const adjustments = [...this.elem.querySelectorAll("tr.adjustment")];
    const lineItems = [...this.elem.querySelectorAll(".line_item_check_box")];
    adjustments.forEach((adjustment) => {
      adjustment.style.display = "none";
    });
    lineItems.forEach((lineItem) => {
      const id = lineItem.dataset.id;
      if (lineItem.checked) {
        adjustments.forEach((adjustment) => {
          if (adjustment.dataset.invoiceId == id) {
            adjustment.style.display = null;
            selected.push(adjustment);
          }
        });
      }
    });
    adjustments.forEach((adjustment, index) => {
      let checkbox = adjustment.querySelector("input[type=checkbox]");
      if (!selected.includes(adjustment)) {
        checkbox.checked = false;
      }
    });
  }

  selectLineItem(event) {
    NApp.markRowByCheckbox(event.target);
    this.showRelatedAdjustments();
  }

  methodChanged(event) {
    const input = event.target;
    const form = input.closest("form");
    const numberInput = form.querySelector("#payment_number");
    const checkTip = form.querySelector("#check_drop_down");
    if (input.classList.contains("payable")) {
      if (input.getAttribute("text") == "Check") {
        numberInput.value = "";
        numberInput.setAttribute("disabled", true);
        checkTip.classList.remove("hidden");
      } else {
        numberInput.removeAttribute("disabled");
        checkTip.classList.add("hidden");
      }
    }
  }

  tpMethodChanged(event) {
    const input = event.target;
    const form = input.closest("form");
    const numberInput = form.querySelector("#payment_number");
    const dateLabel = form.querySelector(".payment_issue_date label");
    const dateLabelText = dateLabel.childNodes[dateLabel.childNodes.length - 1];
    const checkTip = form.querySelector("#check_drop_down");
    if (input.classList.contains("payable")) {
      if (input.getAttribute("text") == "Check") {
        numberInput.value = "";
        numberInput.setAttribute("disabled", true);
        dateLabelText.textContent = "Check Date";
        checkTip.classList.remove("hidden");
      } else {
        numberInput.removeAttribute("disabled");
        dateLabelText.textContent = "Transaction Date";
        checkTip.classList.add("hidden");
      }
    } else {
      if (input.getAttribute("text") == "Check") {
        dateLabelText.textContent = "Check Date";
      } else {
        dateLabelText.textContent = "Transaction Date";
      }
    }
  }

  payrollMethodChanged(event) {
    const input = event.target;
    const form = input.closest("form");
    const numberInput = form.querySelector(".batch-payment-number");
    if (input.getAttribute("text") == "Check") {
      numberInput.value = "";
      numberInput.setAttribute("disabled", true);
    } else {
      numberInput.removeAttribute("disabled");
    }
  }

  noClearedDate(event) {
    const input = event.target;
    input
      .closest("form")
      .querySelectorAll("input.cleared-date")
      .forEach((elem, index) => {
        elem.dispatchEvent(
          new CustomEvent("disable", { detail: { disabled: input.checked } })
        );
      });
  }

  async setClearedDate(event) {
    try {
      const form = event.target.closest("form");
      const response = await fetch(form.action + ".json", {
        method: "POST",
        body: new FormData(form),
      });
      const result = await response.json();
      document.querySelector("#payment_subtotal_amount").innerHTML =
        NApp.toCurrency(result.amount);
    } catch (ex) {}
  }
}
